import { Roboto_400Regular } from '@expo-google-fonts/roboto';
import { StyleSheet, Dimensions } from 'react-native';
import theme from '../../global/styles/theme';

const Screen = {
  width: Dimensions.get('window').width,
  height: Dimensions.get('window').height,
};

export const styles = StyleSheet.create({
  content: {
    width: '100%',
    flex: 1,
    // paddingTop: 10,
    zIndex: 2,
  },

  content__modal: {
    zIndex: 2,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 0.45,
    shadowRadius: 16,
  },

  content__subheading: {
    marginBottom: 2,

    fontSize: 14,
    fontWeight: 'bold',
    color: theme.colors.grey5,
    fontFamily: theme.fonts.text400,
  },

  content__heading: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#333',
    fontFamily: theme.fonts.text400,
  },

  content__description: {
    paddingTop: 10,
    paddingBottom: 10,

    fontSize: 15,
    fontWeight: '200',
    lineHeight: 22,
    color: '#666',
  },
  cart_layout: {
    justifyContent: 'space-between',
    flexDirection: 'column',
    height: 56,
  },
  cart_detail: {
    paddingLeft: 20,
    paddingRight: 20,
    height: 52,
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon_claw: {
    position: 'absolute',
    top: 2,
    bottom: 0,
    left: Screen.width / 2 - 16,
    right: Screen.width / 2 - 16,
    width: 32,
    height: 6,
  },
  icon_checkout: {
    width: 16,
    height: 16,
  },
  icon_cart: {
    width: 22,
    height: 23,
  },

  favoriteStyle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: theme.colors.grey5,
    marginTop: 16,
    fontFamily: theme.fonts.text500,
    marginBottom: 19,
    marginLeft: 16,
  },

  item: {
    width: 150,
    height: 50,
    backgroundColor: '#3966ae',
    padding: 20,
    marginLeft: 16,
    marginHorizontal: 16,
    borderRadius: 8,
  },
  title: {
    fontSize: 14,
    fontWeight: '700',
    color: theme.colors.white,
    marginLeft: 16,
  },
  subcontainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginLeft: 16,
    marginRight: 16,
  },
  listaagricultores: {
    flexDirection: 'row',
    marginBottom: 16,
    marginLeft: 16,
    marginRight: 16,
  },
  containerFavorito: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
});
